import React, { Component } from 'react';
import {Trans, translate} from 'react-i18next';
import {withRouter} from 'react-router-dom';


class PrivacyPolicyView extends Component {
  constructor(props) {
    super(props);
    this.back = this.back.bind(this);
  }

  back() {
    this.props.history.goBack();
  }

  render() {
    const {t} = this.props;
    return (
      <div className="app__wrapper">
        <div className="text-page">
        <Trans i18nKey="policy_section_1">
          <h1>POLITIQUE DE CONFIDENTIALITÉ</h1>
        </Trans>
        <Trans i18nKey="policy_section_2">
          <p>Bienvenue sur le site internet Pizzahut.lu. Ce site est exploité conjointement par deux sociétés de droits
            luxembourgeois (Happy Pizza SA et La Varenne Groupe) elles-mêmes franchisées de la compagnie Yum! Brands
            RSC, 1900 Colonel Sanders Lane, Louisville, KY 40213
          </p>
        </Trans>
        <Trans i18nKey="policy_section_3">
          <p>
            En vous connectant ou en consultant le site internet, vous reconnaissez avoir lu, compris et accepté, sans
            limitation ni réserve, la charte sur la protection des données à caractère personnel (la « charte »).<br/>
            La charte vise à vous informer des droits et libertés que vous pouvez faire valoir à l\’égard de notre
            utilisation de vos données personnelles et décrit les mesures que nous mettons en œuvre afin de les
            protéger.<br/>
            <strong>Pizza Hut</strong> est responsable des traitements de données personnelles relatifs à la gestion du
            site internet. Ce traitement est mis en œuvre conformément à la règlementation en vigueur.
          </p>
        </Trans>
        <Trans i18nKey="policy_section_4">
          <h2>1. FINALITÉ DU TRAITEMENT ET TYPES DE DONNÉES COLLECTÉES</h2>
          <p>
            Lors de votre visite du site internet, vous êtes susceptibles de nous fournir un certain nombre de données personnelles telles que vos nom et prénom et coordonnées. Dans le cadre d’une politique de recrutement, nous pouvons en particulier collecter certaines de vos données personnelles. Dans nos formulaires en ligne, les champs obligatoires sont marqués d’un astérisque. À défaut de réponse aux questions obligatoires, nous ne serons pas en mesure de vous répondre. Vos données personnelles ne seront pas traitées ultérieurement de manière incompatible avec les finalités décrites ci-dessus.
            Elles sont uniquement conservées pendant la durée nécessaire à la rréalisation de ces finalités.
          </p>
        </Trans>
        <Trans i18nKey="policy_section_5">
          <h2>2. DESTINATAIRES DES DONNÉES</h2>
          <p>
            Vos données personnelles qui nous seront communiquée dans le cadre d’un processus de recrutement ne seront en aucun cédées à des tiers. Seuls les cadres en charge du recrutement au sein de Happy Pizza et La Varenne auront accès à celles-ci durant la seule période de recrutement. Sitôt le ou les postes attribués, les candidatures non retenues seront éliminées.
          </p>
        </Trans>
        <Trans i18nKey="policy_section_6">
          <h2>3. SÉCURITÉ ET CONFIDENTIALITÉ DE VOS DONNÉES</h2>
          <p>
            Pizza Hut met en œuvre des mesures appropriées pour préserver la sécurité et la confidentialité de vos données personnelles et, notamment, pour empêcher qu’elles soient déformées, endommagées, ou que des tiers non autorisés y aient accès.
          </p>
        </Trans>
        <Trans i18nKey="policy_section_7">
          <h2>4. GESTION DES COOKIES</h2>

          <h3>4.1 Principe</h3>
          <p>
            Un cookie est un fichier qui permet d’enregistrer des informations relatives à la navigation de votre ordinateur sur le site internet (ex. nombres de visites, nombre de pages vues…) et permet notamment de faciliter vos visites sur le site. Vous pouvez à tout moment supprimer les « cookies » installés sur votre ordinateur, vous opposer à l\’enregistrement de nouveaux « cookies » et recevoir une notification avant l’installation d’un nouveau cookie en configurant votre outil de navigation via les instructions figurant ci-dessous « Types de cookies, cookies et statistiques et paramétrage ».
          </p>
          <p>
            Veuillez noter que si vous désinstallez un « cookie » ou si vous vous opposez à l’installation de « cookies » sur votre machine, vous risquez de ne pas être en mesure de bénéficier de certains des services du site internet.
          </p>
        </Trans>
        <Trans i18nKey="policy_section_8">
          <h2>4.2 Types de cookies, cookies et statistiques et paramétrage</h2>

          <p>
            Les cookies qui peuvent être installés sur votre serveur lorsque vous naviguez sur le site sont des cookies qui ont soit pour finalité exclusive de permettre ou de faciliter la communication par voie électronique ou qui sont strictement nécessaires à la fourniture du service que vous demandez (cookies de langues, cookies d’identification …), soit des cookies de statistiques ou autres cookies dans les conditions décrites ci-dessous. Lorsque les cookies exigent votre accord préalable à leur installation nous vous le demandons au moyen du lien « pour en savoir plus », figurant sur la première page du site internet, étant précisé que la poursuite de votre navigation sur le site vaut acceptation.
          </p>

          <h3>4.2.1 Quels sont les cookies installés ?</h3>
          <p>
            Les cookies proposés par le responsable de traitement
          </p>
        </Trans>
        <Trans i18nKey="policy_section_9">
          <div className="text-page__table-wrap">
            <table className="text-page-table">
              <thead>
              <Trans i18nKey="policy_section_9_1">
                <tr>
                  <th>Cookies</th>
                  <th>Description</th>
                  <th>Comment refuser</th>
                  <th>Validité</th>
                </tr>
              </Trans>
              </thead>
              <tbody>
              <Trans i18nKey="policy_section_9_2">
                <tr>
                  <td>lang</td>
                  <td>Stockage de la langue choisie sur le site</td>
                  <td>Voir l'article 4.2.2</td>
                  <td>10 jours</td>
                </tr>
              </Trans>
              <Trans i18nKey="policy_section_9_3">
                <tr>
                  <td>_gat</td>
                  <td>Suivi Google Analytics Differencie les utilisauters et les sessions</td>
                  <td>Voir l'article 4.2.2</td>
                  <td>10 mins</td>
                </tr>
              </Trans>
              <Trans i18nKey="policy_section_9_4">
                <tr>
                  <td>_gid</td>
                  <td>Suivi Google Analytics Differencie les utilisauters et les sessions</td>
                  <td>Voir l'article 4.2.2</td>
                  <td>1 heure</td>
                </tr>
              </Trans>
              <Trans i18nKey="policy_section_9_5">
                <tr>
                  <td>_ga</td>
                  <td>Suivi Google Analytics Differencie les utilisauters et les sessions</td>
                  <td>Voir l'article 4.2.2</td>
                  <td>2 ans</td>
                </tr>
              </Trans>
              <Trans i18nKey="policy_section_9_6">
                <tr>
                  <td>PHPSESSID</td>
                  <td>Cookie de Session PHP</td>
                  <td>Voir l'article 4.2.2</td>
                  <td>Duree de la session</td>
                </tr>
              </Trans>
              </tbody>
            </table>
          </div>
        </Trans>
        <Trans i18nKey="policy_section_10">
          <p>
            Les cookies de statistiques permettent de mesurer le nombre de visites, le nombre de pages vues ainsi que l’activité des utilisateurs sur le site et leur fréquence de retour. Votre adresse IP est également
            collectée afin de déterminer la ville depuis laquelle vous vous connectez. Celle-ci est immédiatement anonymisée après utilisation empêchant votre identification en tant que personne physique. Les données
            statistiques de fréquentation sont recueillies par le prestataire Google Analytics et sont par la suite restituées au responsable de traitement de façon agrégée et anonyme dans une interface web à laquelle il a
            seul accès. Les données recueillies ne sont pas cédées à des tiers ni utilisées à d’autres fins.
          </p>
        </Trans>
        <Trans i18nKey="policy_section_11">
          <h3>4.2.2 Comment supprimer, être averti de l’installation de cookies ou paramétrer votre navigateur ?</h3>
        </Trans>
        <section>
          {t('policy_section_12')}
          <div>
            Google Chrome:
            <a href="https://support.google.com/chrome/answer/95647?hl=fr">
              https://support.google.com/chrome/answer/95647?hl=fr
            </a>
          </div>
          <div>
            Internet Explorer:
            <a href="http://windows.microsoft.com/fr-fr/internet-explorer/delete-manage-cookies#ie=ie-11">
              http://windows.microsoft.com/fr-fr/internet-explorer/delete-manage-cookies#ie=ie-11
            </a>
          </div>
          <div>
            Mozilla Firefox:
            <a href="http://support.mozilla.org/fr/kb/activer-desactiver-cookies">
              http://support.mozilla.org/fr/kb/activer-desactiver-cookies
            </a>
          </div>
          <div>
            Safari:
            <a href="http://www.apple.com/fr/privacy/use-of-cookies">
              http://www.apple.com/fr/privacy/use-of-cookies
            </a>
          </div>
        </section>
        <Trans i18nKey="policy_section_13">
          <h2>5. VOS DROITS</h2>
          <p>
          Conformément à la réglementation en vigueur, vous disposez d’un droit d’accès, d’interrogation, de modification, de rectification, de suppression et d’opposition pour motifs légitimes au traitement et à la
          diffusion de vos données personnelles. Vous disposez également d’un droit d’opposition, de consentement préalable à la prospection commerciale dans les conditions de la réglementation applicable et de
          définir des directives relatives au sort de vos données à caractère personnel après votre décès. Vous pouvez demander la communication de vos données personnelles. Le responsable des traitements se
            réserve toutefois le droit de refuser toute demande qui serait considérée comme abusive. Veuillez adresser votre demande via le formulaire de contact <a href='http://pizzahut.lu/contact'>http://pizzahut.lu/contact</a> par mail à notre Data Protection
            Officer : <a href='mailto:vje@mikadoplus.lu'>vje@mikadoplus.lu</a> ou par courrier postal à l’adresse suivante :
          </p>
        </Trans>
        <p>
          Pizza Hut Luxembourg c/o Mikado <br/>
          58 rue des Celtes <br/>
          L-1318 Luxembourg <br/>
        </p>

        <div className="text-page__divider">
        </div>
        <Trans i18nKey="policy_section_14">
          <p>
            Pour le Groupe La Varenne exploitant les restaurants Pizza Hut de Mersch, Pommerloch, Wemperhardt, Mertert et Remich, le Data Protection Officer est :
          </p>
        </Trans>

        <p>
          M. Sam PINTO<br/>
          2, route nationale 1<br/>
          L-6776 Grevenmacher<br/>
          <a href="mailto:sam.pinto@la-varenne.lu">sam.pinto@la-varenne.lu</a>
        </p>

      </div>
      </div>
    );
  }
}


export default withRouter(translate('translations')(PrivacyPolicyView));



// WEBPACK FOOTER //
// ./src/components/App/PrivacyPolicyView.js